import {CreatorResponseDto} from "../../general-types/creators.dto";
import {BriefResponseDto} from "../../general-types/briefs.dto";

export interface FilterItemDto {
  id: number | string;
  name: string;
  value?: any;
  icon?: IIcon;
  type?: string;
  class?: string;
  description?: string;
  direction?: 'ASC' | 'DESC';
  image?: string;
  active?: boolean;
}

export interface IIcon {
  name: string;
  type: 'fas' | 'far' | 'fab';
  fill?: string;
  stroke?: string;
  strokeWidth?: string;
  size?: number;
  class?: string;
}

export interface NotificationMessage {
  message: string;
  timestamp?: Date;
  type: NotificationType;
  translate?: boolean;
}

export enum NotificationType {
  success = 0,
  warning = 1,
  error = 2,
  info = 3
}

export enum NotificationClass {
  success = 'notification-success',
  warning = 'notification-warning',
  error = 'notification-error',
  info = 'notification-info'
}

export interface BriefApplicantAction {
  applicant: any;
  actionType: ActionTypesEnum;
}

export interface VideoControls {
  autoplay: boolean;
  showControls: boolean;
  controls: {
    playPause: boolean;
    volume: boolean;
    progressBar: boolean;
    timeDisplay: boolean;
    fullScreen: boolean;
    moreOptions: boolean;
  };
}

export enum ActionTypesEnum {
  APPROVE_VIDEO = 'approve_video',
  INVITE_TO_BRIEF = 'invite_to_brief',
  REVOKE_INVITATION = 'revoke_invitation',
  REMOVE_HIRE = 'remove_hire',
  HIRE = 'hire',
  DECLINE_APPLICATION = 'DECLINE_APPLICATION',
  PORTFOLIO_ACTION = 'portfolio_action',
  VIEW_MESSAGE = 'view_message',
  BACK_TO_APPLIED = 'back_to_applied',
  ASK_TO_CONNECT_TIKTOK = 'ask_to_connect_tiktok',
  ASK_TO_CONNECT_INSTAGRAM = 'ask_to_connect_instagram',
  ASK_TO_CONNECT_YOUTUBE = 'ask_to_connect_youtube',
  ASK_TO_CONNECT_SNAPCHAT = 'ask_to_connect_snapchat',

}

export interface InvitesCounter {
  creators: CreatorResponseDto[];
  brief: BriefResponseDto;
}

export const declineReasons: FilterItemDto[] = [
  {id: 1, name: 'Wrong demographic', icon: {name: 'person_remove', type: 'fas'}, class: 'bg-red-400 hover:bg-red-500 text-white'},
  {id: 2, name: 'Incomplete profile', icon: {name: 'document_incomplete', fill: '#1F2937', class: 'text-gray-800', type: 'fas'}, class: 'bg-red-400 hover:bg-red-500 text-white'},
  {id: 3, name: 'Private account', icon: {name: 'padlock', type: 'fas'}, class: 'bg-red-400 hover:bg-red-500 text-white'},
  {id: 4, name: 'Not enough followers', icon: {name: 'trending_down', type: 'fas'}, class: 'bg-red-400 hover:bg-red-500 text-white'},
  {id: 5, name: 'Meme/fan page', icon: {name: 'theatre_masks', fill: '#1F2937', class: 'text-gray-800', type: 'fas'}, class: 'bg-red-400 hover:bg-red-500 text-white'},
  {id: 6, name: 'Incorrect handle', icon: {name: 'warning', type: 'fas'}, class: 'bg-red-400 hover:bg-red-500 text-white'},
  {id: 7, name: 'Sorry, you haven`t been selected', icon: {name: 'cancel_circle', type: 'fas'}, class: 'bg-red-400 hover:bg-red-500 text-white'},
  {id: 8, name: 'Other', icon: {name: 'question_circle', type: 'fas'}, class: 'bg-red-400 hover:bg-red-500 text-white'},
];


export const unHireReasons: FilterItemDto[] = [
  {id: 1, name: 'Unresponsive Creator', icon: {name: 'question_circle', type: 'fas'}, class: 'bg-red-400 hover:bg-red-500 text-white'},
  {id: 2, name: 'Not completed in time', icon: {name: 'close', type: 'fas'}, class: 'bg-red-400 hover:bg-red-500 text-white'},
  {id: 3, name: 'Creator requested removal', icon: {name: 'person_remove', type: 'fas'}, class: 'bg-red-400 hover:bg-red-500 text-white'},
  {id: 4, name: 'Campaign was over-hired', icon: {name: 'people', type: 'fas'}, class: 'bg-red-400 hover:bg-red-500 text-white'},
  {id: 8, name: 'Other', icon: {name: 'question_circle', type: 'fas'}, class: 'bg-red-400 hover:bg-red-500 text-white'},
];

export interface DateParts {
  day: number;
  month: string; // 'Sep'
  year: number;
}

export interface ActionMenuItem {
  id: number;
  label: string;
  icon: IIcon;
  class: string;
  action: string;
  disabled?: boolean;
  danger?: boolean;
}


